export const reportsResultsSiteCoreKeys = {
  header: "Reports.Results",

  allProgramsHeader: "Reports.Results.AllProgramsHeader",
  programKey: "Reports.Results.ProgramKeyTableColumn",
  clientName: "Reports.Results.ClientNameTableColumn",
  type: "Reports.Results.TypeTableColumn",
  programStatusDropDown: "Reports.Results.ProgramStatusDropDownTableColumn",
  participantName: "Reports.Results.ParticipantNameTableColumn",
  localClientRelationshipOwner:
    "Reports.Results.LocalClientRelationshipOwnerTableColumn",
  totalProgramFee: "Reports.Results.TotalProgramFeeTableColumn",
  totalTaxInvoicedTillDate:
    "Reports.Results.TotalTaxInvoicedTillDateTableColumn",
  totalExpensesInvoicedTillDate:
    "Reports.Results.TotalExpensesInvoicedTillDateTableColumn",
  totalFeesInvoicedTillDate:
    "Reports.Results.TotalFeesInvoicedTillDateTableColumn",
  outstandingAmount: "Reports.Results.OutstandingAmountTableColumn",
  billingContact: "Reports.Results.BillingContactTableColumn",
  poNumber: "Reports.Results.PONumberTableColumn",
  productLine: "Reports.Results.ProductLineTableColumn",
  programTemplate: "Reports.Results.ProgramTemplateTableColumn",
  alternateProgramTemplateName:
    "Reports.Results.AlternateProgramTemplateNameTableColumn",
  programStatusList: "Reports.Results.ProgramStatusList",
  hrContact: "Reports.Results.HRContactTableColumn",
  costCenter: "Reports.Results.CostCentreTableColumn",
  businessUnit: "Reports.Results.BusinessUnitTableColumn",
  deliveryOffice: "Reports.Results.DeliveryOfficeTableColumn",
  nextView: "Reports.Results.NextViewTableColumn",
  actualStartDate: "Reports.Results.ActualStartDateTableColumn",
  typeList: "Reports.Results.TypeList",
  marketOfDeliveryOffice: "Reports.Results.MarketForDeliveryOfficeTableColumn",
  deliveryOfficeTableColumn: "Reports.Results.DeliveryOfficeTableColumn",
  programStatusDropDownTableColumn:
    "Reports.Results.ProgramStatusDropDownTableColumn",
  notificationSupportDateTableColumn:
    "Reports.Results.NotificationSupportDateTableColumn",
  outreachEligibleDateTableColumn:
    "Reports.Results.OutreachEligibleDateTableColumn",
  stateRegionProvinceTableColumn:
    "Reports.Results.StateRegionProvinceTableColumn",
  alternateEmailIDTableColumn: "Reports.Results.AlternateEmailIDTableColumn",
  alternatePhoneNumberTableColumn:
    "Reports.Results.AlternatePhoneNumberTableColumn",
  registrationStatusNEXTTableColumn:
    "Reports.Results.RegistrationStatusNEXTTableColumn",
  primaryPhoneNumberTableColumn:
    "Reports.Results.PrimaryPhoneNumberTableColumn",
  primaryEmailIDTableColumn: "Reports.Results.PrimaryEmailIDTableColumn",
  primaryManagedStatusTableColumn:
    "Reports.Results.PrimaryManagedStatusTableColumn",
  outreachEligibleStatusTableColumn:
    "Reports.Results.OutreachEligibleStatusTableColumn",
  secondaryManagedStatusTableColumn:
    "Reports.Results.SecondaryManagedStatusTableColumn",
  programKeyTableColumn: "Reports.Results.ProgramKeyTableColumn",
  programResultKey: "Reports.Results.ProgramKeyTableColumn",
  nextContactDateTableColumn: "Reports.Results.NextContactDateTableColumn",
  lastActivityDateTableColumn: "Reports.Results.LastActivityDateTableColumn",
  mustStartByDateTableColumn: "Reports.Results.MustStartByDateTableColumn",
  contactWithin24HrsTableColumn:
    "Reports.Results.ContactWithin24HrsTableColumn",
  appendedOtherPhoneTableColumn:
    "Reports.Results.AppendedOtherPhoneTableColumn",
  registrationEmailIdNextTableColumn:
    "Reports.Results.RegistrationEmailIDNEXTTableColumn",
  releaseDateTableColumn: "Reports.Results.ReleaseDateTableColumn",
  notificationDateTableColumn: "Reports.Results.NotificationDateTableColumn",
  nisIdTableColumn: "Reports.Results.NISIDTableColumn",
  bestMatchPreferenceTableColumn:
    "Reports.Results.BestMatchPreferenceTableColumn",
  registrationCodeTableColumn: "Reports.Results.RegistrationCodeTableColumn",
  programTemplateResultTableColumn:
    "Reports.Results.ProgramTemplateResultTableColumn",
  participantNameResultTableColumn:
    "Reports.Results.ParticipantNameResultTableColumn",
  registrationStatusNextList: "Reports.Results.NextRegistrationStatusList",
  programStatusResultTableColumn:
    "Reports.Results.ProgramStatusResultTableColumn",
  outreachEligibleStatusList: "Reports.Results.OutreahEligibleStatusList",
  primaryManagedStatusList: "Reports.Results.PrimaryManagedStatusList",
  secondaryManagedStatusList: "Reports.Results.SecondaryManagedStatusList",
  stateRegionProvinceList: "Reports.Results.StateRegionProvinceList",
  assignedCoach: "Reports.Results.AssignedCoach",
  activeAssignments: "Reports.Results.ActiveAssignments",
  openAssignments: "Reports.Results.OpenAssignments",
  inactiveAssignments: "Reports.Results.InactiveAssignments",

  dossierNumberTableColumn: "Reports.Results.DossierNumberTableColumn",
  clientTypeTableColumn: "Reports.Results.ClientTypeTableColumn",
  actualClientTableColumn: "Reports.Results.ActualClientTableColumn",
  invoiceNumberTableColumn: "Reports.Results.InvoiceNumberTableColumn",
  invoiceDateTableColumn: "Reports.Results.InvoiceDateTableColumn",
  invoiceAmountTableColumn: "Reports.Results.InvoiceAmountTableColumn",
  invoiceLineNumberTableColumn: "Reports.Results.InvoiceLineNumberTableColumn",
  invoiceLineItemDetailsTableColumn:
    "Reports.Results.InvoiceLineItemDetailsTableColumn",
  invoiceLineTotalBillingAmountTableColumn:
    "Reports.Results.InvoiceLineTotalBillingAmountTableColumn",
  clientTypeList: "Reports.Results.ClientTypeList",
  billingItemTypeList: "Reports.Results.BillingItemTypeList",
};

export const selectReportSiteCoreKeys = {
  header: "Reports.SelectReport",
  reportCategoryDropDown: "Reports.SelectReport.ReportCategoryDropDown",
  reportTypeDropDown: "Reports.SelectReport.ReportTypeDropDown",
  viewReportsButton: "Reports.SelectReport.ViewReportsButton",
  changeReportHeader: "Reports.SelectReport.ChangeReportPopupHeader",
  fromDate: "Reports.SelectReport.ReportFromDate",
  toDate: "Reports.SelectReport.ReportToDate",
  reportTypeList: "Reports.SearchReports.ReportTypeList",
  //report type sitecore keys
  pendingBillingList: "ReportType.PendingBillingList",
  outreachList: "ReportType.OutreachList",
  notificationStatus: "ReportType.NotificationStatus",
  coachCaseloads: "ReportType.CoachCaseloads",
  ncbpReport: "ReportType.NCBPReport",
};

export const reportHeaderSiteCoreKeys = {
  header: "Reports.ReportsHeader",
  changeBtn: "Reports.ReportsHeader.ChangeButton",
};

export const reportsSearchReportsSiteCoreKeys = {
  header: "Reports.SearchReports",

  officeTypeDropDown: "Reports.SearchReports.OfficeTypeDropDown",
  officeTypeList: "Reports.SearchReports.OfficeList",
  includeClosedDropDown: "Reports.SearchReports.IncludeClosedDropDown",
  includeClosedList: "Reports.SearchReports.IncludeClosedList",
  clientNameDropDown: "Reports.SearchReports.ClientNameDropDown",
  productLineDropDown: "Reports.SearchReports.ProductLineDropDown",
  programTemplateDropDown: "Reports.SearchReports.ProgramTemplateDropDown",
  hasOutstandingAmountCheckbox:
    "Reports.SearchReports.HasOutstandingAmountCheckbox",
  outstandingAmountDropDown: "Reports.SearchReports.OutstandingAmountDropDown",

  currencyDropDown:
    "Reports.SearchReports.OutstandingAmountDropDown.CurrencyDropDown",
  maxAmount: "Reports.SearchReports.OutstandingAmountDropDown.MaxAmount",
  minAmount: "Reports.SearchReports.OutstandingAmountDropDown.MinAmount",
  AllCurrenciesOption:
    "Reports.SearchReports.OutstandingAmountDropDown.CurrencyDropDown.AllCurrenciesOption",
  minMustBeGreaterThanZero:
    "Reports.SearchReports.OutstandingAmountDropDown.MinAmountMustBeGreaterThanZero",
  minMustBeLessThanMax:
    "Reports.SearchReports.OutstandingAmountDropDown.MinAmountMustBeLessThanTheMaxAmount",
  maxMustBeGreaterThanMin:
    "Reports.SearchReports.OutstandingAmountDropDown.MaxAmountMustBeGreaterThanTheMinAmount",
  minMaxRequired:
    "Reports.SearchReports.OutstandingAmountDropDown.PleaseEnterMinAndMaxAmount",
  marketForDeliveryOfficeDropDown:
    "Reports.SearchReports.MarketForDeliveryOfficeDropDown",
  coachesDropDown: "Reports.SearchReports.CoachesDropDown",

  dossierNumber: "Reports.SearchReports.DossierNumber",
  actualClient: "Reports.SearchReports.ActualClient",
  nonClientBillingParty: "Reports.SearchReports.NonClientBillingParty",
  invoiceEndDate: "Reports.SearchReports.InvoiceEndDate",
  invoiceStartDate: "Reports.SearchReports.InvoiceStartDate",
  actualClientNotificationIconMessage:
    "Reports.SearchReports.ActualClientNotificationIconMessage",
  invoiceEndDateNotificationIconMessage:
    "Reports.SearchReports.InvoiceEndDateNotificationIconMessage",
  invoiceStartDateValidationMessage:
    "Reports.SearchReports.InvoiceStartDateValidationMessage",
};

export const powerBIReportSiteCoreKeys = {
  header: "Reports.PowerBIReport",
  openInNewPageConfirmation:
    "Reports.PowerBIReport.ReportsOpenInNewTabConfirmation",
  stayHere: "Reports.PowerBIReport.StayHereButton",
  powerBIReportList: "PowerBIReport.PowerBIReportList",
};
